import { createFileRoute } from "@tanstack/react-router";
import {
  parseNotificationSearch,
  type NotificationSearch,
} from "@/features/notifications/page/notification-search";

// "Thông báo của tôi" (20/10/2026): bộ lọc nằm trên URL — chuông dẫn sang
// `/notifications?status=unread`. Giá trị lạ thì bỏ qua, không làm hỏng trang.
export const Route = createFileRoute("/_app/notifications")({
  validateSearch: (search: Record<string, unknown>): NotificationSearch => parseNotificationSearch(search),
});
